import fetch from '../auth/FetchInterceptor'

const DropShippingServices = {}
const ServiceURL = '/dropshipping'

DropShippingServices.getAll = function (data) {
    return fetch({
        url: ServiceURL+'/links',
        method: 'post',
        data:data
    })
}

DropShippingServices.createDropLink = function (data) {
    return fetch({
        url: ServiceURL+'/addDropLink',
        method: 'post',
        data : data
    })
}

DropShippingServices.createDropRequest = function (data) {
    return fetch({
        url: ServiceURL+'/addDropReq',
        method: 'post',
        data : data
    })
}
DropShippingServices.ModifyDropReqStatus = function (data) {
    return fetch({
        url: ServiceURL+'/ModifyDropReqStatus',
        method: 'post',
        data : data
    })
}

DropShippingServices.listDropRequest = function (code) {
    return fetch({
        url: ServiceURL+'/listDropReq/'+code,
        method: 'get',
    })
}

DropShippingServices.getByCode = function (code) {
    return fetch({
        url: ServiceURL+'/byCode/'+code,
        method: 'get'
    })
}

DropShippingServices.getByRef = function (ref) {
    return fetch({
        url: ServiceURL+'/getDropReq/'+ref,
        method: 'get'
    })
}

export default DropShippingServices
